// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AddCircleIcon from "@mui/icons-material/AddCircle";
import AssignmentIcon from "@mui/icons-material/Assignment";


class PaymentCreateModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: AddCircleIcon,
            buttonLabel: 'Добавить',
            buttonColor: 'success',
            modalLabel: 'Создание входящего платежа',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields() {
        const url = `payment/create_form/`;
        const api = new BaseApi();
        let fields = [
            'revenue',
            'currency',
            'date',
        ]
        if (!this.props.opportunity){
            fields.push('opportunity')
        }
        let response = await api.get(
            url,
            {
                fields: JSON.stringify(fields)
            }
        );
        return (response.data)
    }

    async processForm(form) {
        let formDataObj = Object.fromEntries(
            form.state.formData.entries()
        );
        if (this.props.opportunity){
            formDataObj.opportunity = this.props.opportunity.id;
        }
        const url = `payment/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formDataObj
        );
        if (response.status === 201) {
            if (this.props.callBack){
                await this.props.callBack()
            }
            this.setModalOpenFalse();
        }
        return response
    }
}

export default PaymentCreateModal
